import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../SEO/SEO';
import JsonLd from '../JsonLd/JsonLd';
import MainNav from '../MainNav/MainNav';
import Footer from '../Footer/Footer';
import '../../pages/ServiciosPage/ServiciosPage.css';
import CoberturaNota from '../CoberturaNota/CoberturaNota';
import './SeoLandingLayout.css';

const buildFaqSchema = (items, pageUrl) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  url: pageUrl,
  mainEntity: items.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
});

const SeoLandingLayout = ({
  darkMode,
  toggleDarkMode,
  title,
  description,
  keywords,
  canonical,
  h1,
  lede,
  children,
  faqItems = [],
  serviceJsonLd,
  serviceJsonLdId = 'jsonld-service-page',
  breadcrumbJsonLd,
  ctaTo = '/contacto',
  ctaLabel = 'Revisar mi caso',
  footerCtaTo,
  footerCtaLabel,
  cobertura = false,
}) => {
  const faqSchema =
    faqItems.length > 0 ? buildFaqSchema(faqItems, canonical) : null;
  const resolvedFooterTo = footerCtaTo || ctaTo;
  const resolvedFooterLabel = footerCtaLabel || ctaLabel;

  return (
    <>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        canonical={canonical}
      />
      {faqSchema && <JsonLd id="jsonld-faq-page" data={faqSchema} />}
      {serviceJsonLd && (
        <JsonLd id={serviceJsonLdId} data={serviceJsonLd} />
      )}
      {breadcrumbJsonLd && (
        <JsonLd id="jsonld-breadcrumb" data={breadcrumbJsonLd} />
      )}
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <article
        className={`servicios-page seo-landing ${darkMode ? 'dark' : 'light'}`}
      >
        <header
          className={`seo-landing-hero servicios-hero ${darkMode ? 'dark' : 'light'}`}
        >
          <div className="servicios-hero-content">
            <div className="servicios-hero-text">
              <h1 className="servicios-hero-title">{h1}</h1>
              {lede && (
                <p className="servicios-hero-subtitle servicios-hero-tagline">
                  {lede}
                </p>
              )}
              <div className="servicios-hero-cta-wrapper">
                <Link to={ctaTo} className="servicios-hero-cta">
                  {ctaLabel}
                </Link>
              </div>
            </div>
          </div>
        </header>
        <div className="seo-landing-body">{children}</div>
        {cobertura && (
          <div className="seo-landing-body">
            <CoberturaNota />
          </div>
        )}
        {faqItems.length > 0 && (
          <div className="seo-landing-body seo-landing-faq">
            <h2>Preguntas frecuentes</h2>
            {faqItems.map((item) => (
              <details key={item.question}>
                <summary>{item.question}</summary>
                <p>{item.answer}</p>
              </details>
            ))}
          </div>
        )}
        <div className="seo-landing-body seo-landing-footer-cta">
          <Link to={resolvedFooterTo} className="seo-landing-cta">
            {resolvedFooterLabel}
          </Link>
        </div>
      </article>
      <Footer darkMode={darkMode} />
    </>
  );
};

export default SeoLandingLayout;
